<template>
  <div class="mt-5" v-if="subtestAttempts.length > 0">
    <h3>{{ translate('subtest-attempts.table_title') }}</h3>
    <div class="table-wrapper">
      <table class="table card-table mb-0">
        <thead>
        <tr class="bg-light text-muted">
          <th>{{ translate('subtest-attempts.columns.test') }}</th>
          <th>{{ translate('subtest-attempts.columns.test_variation') }}</th>
          <th>{{ translate('subtest-attempts.columns.subtest_type') }}</th>
          <th>{{ translate('subtest-attempts.columns.writing_submitted') }}</th>
          <th>{{ translate('subtest-attempts.columns.speaking_appointment') }}</th>
          <th>{{ translate('subtest-attempts.columns.grade') }}</th>
          <th>{{ translate('subtest-attempts.columns.details') }}</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="subtestAttempt in subtestAttempts">
          <td>
            <img :src="subtestAttempt.subtest.test_type.icon_path" class="icon" alt="icon">
          </td>
          <td>{{ subtestAttempt.subtest.test_variation['title_' + app.locale] }}</td>
          <td>{{ subtestAttempt.subtest.subtest_type['title_' + app.locale] }}</td>
          <td v-if="subtestAttempt.writing_submitted_at">{{ subtestAttempt.writing_submitted_at | datetime }}</td>
          <td v-else>{{ translate('subtest-attempts.not_submitted') }}</td>
          <td>{{ subtestAttempt.speaking_appointment_at | datetime }}</td>
          <td v-if="subtestAttempt.grade">{{ subtestAttempt.grade }}</td>
          <td v-else>{{ translate('subtest-attempts.not_graded') }}</td>
          <td>
            <a :href="'/subtest-attempts/' + subtestAttempt.id">
              {{ translate('subtest-attempts.to_feedback') }}
            </a>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {

  mixins: [require('../../../../resources/js/mixin')],

  data () {
    return {
      subtestAttempts: []
    };
  },

  mounted () {
    this.getSubtestAttempts();
  },

  methods: {
    /**
     * Get the SubtestAttempts.
     */
    getSubtestAttempts () {
      let self = this;

      axios.get('/api/subtest-attempts')
        .then(function (response) {
          self.subtestAttempts = response.data.subtestAttempts;
        });
    },
  }
};
</script>

<style>
.icon {
    height: 22px;
}
</style>
